import React from 'react'

import { ConfirmationModal, T } from 'src/govwell-ui'

type Props = {
  onClose: () => void
  onConfirm: () => Promise<void>
  onClosed: () => void
}

const DeleteLetterheadModal = ({ onClose, onConfirm, onClosed }: Props) => {
  return (
    <ConfirmationModal
      title="Delete Letterhead"
      cancelText="Cancel"
      confirmText="Delete letterhead"
      isDestructive
      onCancel={onClose}
      onConfirm={onConfirm}
      onClosed={onClosed}
    >
      <T.Body>
        Are you sure you want to delete this letterhead? This action cannot be undone.
      </T.Body>
    </ConfirmationModal>
  )
}

export default React.memo(DeleteLetterheadModal)
